export default "__VITE_ASSET__CGFW2ZKy__"